<template>
    <div class="fixed flex justify-center items-center w-full h-full bg-white bg-opacity-60">
        <div class="flex border shadow-md border-gray-200 rounded p-3">
            <div class="relative border-4 border-gray-200 mr-3 rounded-full w-7 h-7 animate-spin">
                <div class="absolute bg-brand spinner-dot rounded-full"></div>
            </div>
            <span class="pt-1 text-gray-700 align-text-bottom animate-bounce">carregando...</span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="css" scoped>
.spinner-dot
{ width: 8px; height: 8px; top: -4px; left: 0px; }
</style>